import { ctaTriggerAndNavigate } from '@/helpers/ctaTriggerAndNavigate';
import { navigateMediaItem } from '@/helpers/navigateMediaItem';
import { trackStoreeelEvent } from "@/helpers/trackStoreeelEvent";
import localStorageRepositories from "@/plugins/localStorageRepositories";

export const swipeCtaAction = () => {
  // モバイル表示時のみ有効
  if (!window.storeeelItems || !window.storeeelItems.isMobile) return;

  const wrappers = document.querySelectorAll('.storeeel-swiper-group-wrapper .slide-media-wrapper');
  const threshold = 100;

  wrappers.forEach((wrapper) => {
    let startY = 0;
    let moveY = 0;
    let distance = 0;
    let startScrollTop = 0;
    let consumedPullDown = false;

    wrapper.addEventListener('touchstart', (e) => {
      startY = e.touches[0].clientY;
      // 計測開始時点のスクロール位置（ページが最上部か判定）
      const scrollingEl = document.scrollingElement || document.documentElement;
      startScrollTop = (scrollingEl && typeof scrollingEl.scrollTop === 'number') ? scrollingEl.scrollTop : (window.pageYOffset || 0);
      consumedPullDown = false;
      distance = 0;
    }, { passive: true });

    wrapper.addEventListener('touchmove', (e) => {
      moveY = e.touches[0].clientY;
      distance = moveY - startY;

      // ページ最上部での下方向スワイプ（プル・トゥ・リフレッシュ）を抑止
      if (startScrollTop <= 0 && distance > 0) {
        e.preventDefault();
        consumedPullDown = true;
      }
    }, { passive: false });

    wrapper.addEventListener('touchend', (e) => {
      if (consumedPullDown) {
        e.preventDefault();
      }

      // 上方向スワイプのみでCTAを発火
      if (distance < -threshold) {
        // square + 最後のスライドの上スワイプは closeSwipeAction が担当するので CTA は発火しない
        const slideEls = Array.from(document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide'));
        const currentSlide = wrapper.closest('.storeeel-swiper-group-wrapper .swiper-slide');
        const idx = slideEls.indexOf(currentSlide);
        const lastIdx = slideEls.length - 1;

        if (!(window.storeeelItems.frame === 'square' && idx === lastIdx)) {
          const contents = navigateMediaItem();
          const currentMovie = contents[window.moviePosition];
          if (currentMovie && currentMovie.ctaText && currentMovie.ctaLink) {
            trackStoreeelEvent('storeeel_cta_click', {
              'storeeel_name': currentMovie.mediaAsset.name,
              'media_id': currentMovie.mediaAsset.id,
              'campaign_id': window.storeeelItems.id,
              });
            localStorageRepositories.get("ctaClick").set(
              currentMovie.mediaAsset.id,
              window.storeeelItems.id
            );
            // ナビゲーション実行
            ctaTriggerAndNavigate(currentMovie.ctaLink);
          }
        }
      }

      // 値をリセット
      startY = 0;
      moveY = 0;
      distance = 0;
    }, { passive: false });
  });
};
